import React, { useEffect, useState } from 'react'
import almavivaCover from '../../../assets/images/featuringAlmaviva.PNG'
import almavivaLogo from '../../../assets/images/almavivaLogo.png'
// import pinchtozoom from '../../../assets/images/pinchtozoom.png'
import logoNacer from '../../../assets/images/logo-nacer.webp'
import getStartedImage from '../../../assets/images/getStartedImage.gif'
import Footer from '../../Footer/Footer'
import { BiArrowBack } from 'react-icons/bi'

const Almaviva = () => {
  const [loading, setLoading] = useState(true)
  // const [showPopupTayaraProject, setShowTayaraProjectPopup] = useState(true)

  useEffect(() => {
    import('./projects.css')
      .then(() => setLoading(false)) // CSS is imported, stop loading
      .catch(() => setLoading(false)) // In case of error, stop loading as well
  }, [])

  // function handleCloseOnboardingTayaraProject() {
  //   setShowTayaraProjectPopup(false)
  // }

  return (
    <div>
      {/* {showPopupTayaraProject && (
        <div
          class="showpopup"
          onClick={(e) => {
            if (e.target !== e.currentTarget) return
            handleCloseOnboardingTayaraProject()
          }}
        >
          <img
            src={pinchtozoom}
            alt="pinch to zoom project images"
            className="NavigationGuide"
          />
          <button onClick={() => handleCloseOnboardingTayaraProject()}>
            Skip
          </button>
        </div>
      )} */}
      {loading ? (
        <div class="spinner-wrap-on-loading">
          <div className="loading-container">
            <img className="logo-on-loading" src={logoNacer} alt="" />
            <div class="spinner-item"></div>
            <div class="spinner-item spinner-item--2"></div>
          </div>
        </div>
      ) : (
        <>
          <div className="bg-black font-sans overflow-hidden">
            <header class="header">
              <a href="https://nacermediouni.vercel.app/">
                <img class="logo" src={logoNacer} alt="" />
              </a>
            </header>
            <div className="absolute flex flex-col z-[9999] top-11 right-6 md:right-12 w-fit h-fit">
               <a
                className=" flex gap-4 items-center text-sm font-bold  text-white hover:text-neutral-500 "
                href="https://nacer-mediouni.netlify.app/works"
              >
                <BiArrowBack size={20} />
                Back to projects
              </a>
              <span className="relative left-10 bottom-3 rotate-90 w-[1px] h-10 bg-[#00ffc6]"></span>
            </div>
            <div className="w-full h-screen bg-[url('/src/assets/images/almavivaFeaturing.PNG')] bg-no-repeat bg-cover lg:bg-cover lg:bg-fixed  bg-center ">
              <div className="absolute inset-0 z-10 w-full h-screen bg-black/80 ">
                <div className="w-full h-full flex flex-col items-center justify-end gap-6 pb-[75%] md:pb-[20%]">
                  {/* <h1 className="text-6xl font-extrabold">Tayara</h1> */}
                  <img
                    src={almavivaLogo}
                    alt="tayara-project-logo"
                    className="w-1/2 lg:w-[20%]"
                  />

                  <p className="mx-4 lg:mx-[15%] text-base lg:text-xl text-center font-medium">
                    A Visa services website provider that handles visa
                    application services for individuals in Tunisia seeking to
                    travel to certain countries.
                  </p>
                  <div className="w-full absolute bottom-10">
                    <div class="scd">
                      <div class="chv"></div>
                      <div class="chv"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="w-full h-full py-10 px-[10%] md:px-[20%] bg-slate-50 text-black ">
              <div className="w-full flex flex-col gap-4">
                <div className="flex flex-col gap-2 text-neutral-600">
                  <h1 className="text-xl font-extrabold">Role</h1>
                  <span className="text-base">UX/UI Designer</span>
                </div>
                <div className="flex flex-col gap-2 text-neutral-600">
                  <h1 className="text-xl font-extrabold">Settings</h1>
                  <span className="text-base">
                    Freelance project with Almaviva Tunisia
                  </span>
                </div>
                <div className="flex flex-col gap-2 text-neutral-600">
                  <h1 className="text-xl font-extrabold">Timeline</h1>
                  <span className="text-base">2024</span>
                </div>
              </div>
            </div>

            <div className="w-full h-full py-10 px-[10%] md:px-[20%] bg-white text-neutral-600 ">
              <div className="w-full flex justify-between items-center flex-wrap gap-4">
                <div className="w-fit">
                  <h1 className="text-3xl md:text-5xl font-extrabold">
                    Almaviva Tunisia
                  </h1>
                  {/* <h1 className="text-base md:text-xl font-extrabold my-2">
                    #1 Most visited Tunisian Classified Marketplace
                  </h1> */}
                </div>
                {/* <a
                  href="https://www.tayara.tn/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className=" p-4 text-sm lg:text-base text-white font-medium bg-neutral-800 hover:bg-transparent hover:text-neutral-800 border-2 border-neutral-800"
                >
                  View final product
                </a> */}
              </div>
              <img
                src={almavivaCover}
                className="w-full my-10 rounded-3xl border-[1px] border-neutral-100"
                alt="almaviva project"
              />
              <p className="text-base md:text-lg  font-normal font-sans my-10">
                <b>Almaviva Tunisia website</b> is a service provider that
                handles visa application services for individuals in Tunisia
                seeking to travel to certain countries. The website facilitates
                the visa process by providing information, collecting
                applications, and coordinating appointments for biometric data
                collection and interviews. Almaviva works closely with embassies
                to streamline the visa process and ensure that applicants meet
                all necessary requirements for their visa applications. They
                focus on enhancing the visa service experience for applicants
                and collaborating with foreign missions.
              </p>

              <div className="w-full justify-between items-center my-10 md:my-14">
                <h1 className="text-xl md:text-2xl font-extrabold my-4">
                  Role & Project
                </h1>
                <p className="text-base md:text-lg">
                  As a UX/UI designer for Almaviva Tunisia, I took a central
                  role in redesigning their homepage, turning feedback from
                  clients and stakeholders into effective design solutions.
                  Starting with an analysis of user behavior, I created
                  wireframes, performed usability testing, and refined
                  prototypes using <b>Figma</b>. My focus was on enhancing
                  navigation, accessibility, and aligning the design with
                  business objectives. The process involved iterative
                  collaboration with the team to deliver a user-friendly,
                  intuitive design.{' '}
                  <span className="underline">
                    The final high-fidelity UI prototypes are now under
                    development
                  </span>
                  , set to enhance the visa application process.
                </p>
              </div>
              <h1 className="text-xl md:text-2xl font-extrabold my-4">
                Wireframes
              </h1>
            </div>

            <div className="relative flex justify-center items-center w-full h-full">
              <div className="absolute top-0 w-full bg-black h-[4rem] z-50 "></div>

              <iframe
                className=" w-full px-[10%] md:px-[20%] md:w-full h-screen"
                src="https://embed.figma.com/design/zavC6hv2ZU8Fh4PiXFjovP/Almaviva?node-id=0-1&embed-host=share"
                allowfullscreen
                title="work"
              ></iframe>

              <div className="absolute bottom-0 w-full bg-black h-[50px] z-50 "></div>
            </div>
            <div className="w-full h-full py-10 px-[10%] md:px-[20%] bg-white text-neutral-600 ">
              <p className="text-base md:text-lg">
                For my contribution to Almaviva Tunisia's homepage redesign, I
                focused on several key improvements based on client feedback and
                user analysis: <br></br>
                <br></br>
                <b>Navigation Menu</b>: Restructured the menu for better
                organization and ease of use, grouping related items and placing
                them in a logical sequence to enhance user navigation. <br></br>
                <br></br>
                <b>Banner Design</b>: Adjusted the banner's size to free up
                space for more relevant content and improved the display of
                important announcements. <br></br>
                <br></br>
                <b>Key Service Features</b>: Added a pre-service section to
                guide users through the visa application process.<br></br>
                <br></br>
                <b>Footer Redesign</b>: Enhanced accessibility and SEO by
                restructuring the footer for better link visibility and
                indexation. <br></br>
                <br></br>
                These changes contributed to a more user-friendly and accessible
                experience, ensuring a smooth user journey from start to finish.
              </p>
              <h1 className="text-xl md:text-2xl font-extrabold mt-14 mb-4">
                Prototypes
              </h1>
            </div>

            <div className="relative w-full h-full mt-10">
              <div className="absolute bottom-1 w-full bg-black h-[50px] z-50 "></div>

              <iframe
                title="work"
                className="relative w-full h-[20rem] md:h-screen"
                src="https://embed.figma.com/proto/zavC6hv2ZU8Fh4PiXFjovP/Almaviva?node-id=165-10658&node-type=canvas&scaling=contain&content-scaling=fixed&page-id=0%3A1&starting-point-node-id=165%3A10658&show-proto-sidebar=1&embed-host=share"
                allowfullscreen
              ></iframe>
            </div>
          </div>
        </>
      )}
      <div className=" bg-black flex flex-col md:flex-row justify-start items-center ">
        <img src={getStartedImage} alt="get started" className="w-[50%]" />
        <div className="w-full h-full gap-10 flex flex-col justify-center items-center md:items-start mx-auto pb-20 md:pb-0">
          <p className="text-3xl lg:text-5xl md:w-[90%] px-[10%] md:px-0 text-center md:text-start font-semibold">
            Want to build remarkable products together?
          </p>
          <a
            href="https://www.linkedin.com/in/nacermediouni/"
            aria-label="Linkedin"
            target="_blank"
            rel="noreferrer"
            className=" text-2xl lg:text-3xl text-[#00ffc6] font-bold underline underline-offset-2 hover:underline-offset-1"
          >
            Let's get strated!
          </a>
        </div>
      </div>

      <div className="  w-full flex flex-col justify-center items-center pt-20 pb-8 px-[10%] md:px-[20%] font-sans bg-white">
        <Footer />
      </div>
    </div>
  )
}

export default Almaviva
